export interface calculateTaxOutput {
  IncludeTaxAmount: number
  ExcludeTaxAmount: number
  TaxAmount: number
  taxDetails: TaxLedger[]
}

interface TaxLedger {
  taxId: any
  taxSchemeId: any
  taxSchemeDetailId: any
  SeqNo: number
  TaxRate: number
  TaxAmount: number
  taxCode: any
  schemeTypeCode: any
}

type TaxSchemeComputeMethod = 'Tax_On_Gross' | 'Tax_On_Taxed_Price'

type TaxSchemeCalculationRuleDto = {
  schemeTypeCode?: any
  taxId?: string
  taxSchemeId?: string
  taxSchemeDetailId?: string
  seqNo?: number
  taxOnSeq?: any[]
  computeMethod?: TaxSchemeComputeMethod
  taxRate?: number
  taxCode?: any
}

const calculateTaxDetail = (
  data: TaxSchemeCalculationRuleDto[],
  amount: any,
  isExclusiveTax: boolean
): calculateTaxOutput => {
  const taxLedgerList: TaxLedger[] = []
  const sortedData = [...data].sort((a, b) => (a.seqNo || 0) - (b.seqNo || 0))

  const parseAmount = amount => {
    if (typeof amount === 'number') return amount

    if (typeof amount === 'string') {
      const cleaned = amount.replace(/,/g, '')
      const number = parseFloat(cleaned)
      return isNaN(number) ? NaN : number
    }

    return 0
  }

  let originalAmount = parseAmount(amount)

  let totalRateIncludeTaxArr = [] as any

  sortedData.forEach(x => {
    let tempRateIncludeTax = 0

    if (x.taxOnSeq && x.taxOnSeq.length > 0) {
      let tempCalRate = 1

      x.taxOnSeq.forEach(y => {
        let tempObj = totalRateIncludeTaxArr.find(z => z.seqNo === y.seqNo)

        if (tempObj) {
          tempCalRate += tempObj.rate
        }
      })

      tempRateIncludeTax += tempCalRate * (x.taxRate! / 100)
    } else {
      tempRateIncludeTax += x.taxRate! / 100
    }

    totalRateIncludeTaxArr.push({
      rate: Number(tempRateIncludeTax.toFixed(4)),
      seqNo: x.seqNo,
    })
  })

  let totalRateIncludeTax = 1
  totalRateIncludeTaxArr.forEach(x => {
    totalRateIncludeTax += x.rate
  })

  sortedData.forEach(x => {
    console.log(x, 'this is sorted x')

    let tempTaxAmount = 0
    let tempObj = totalRateIncludeTaxArr.find(y => y.seqNo === x.seqNo)

    if (isExclusiveTax) {
      tempTaxAmount = originalAmount * tempObj.rate
    } else {
      tempTaxAmount = originalAmount * (tempObj.rate / totalRateIncludeTax)
    }

    tempTaxAmount = Number(tempTaxAmount.toFixed(2))

    taxLedgerList.push({
      taxId: x.taxId,
      taxSchemeId: x.taxSchemeId,
      taxSchemeDetailId: x.taxSchemeDetailId,
      SeqNo: x.seqNo!,
      TaxAmount: tempTaxAmount,
      // TaxAmount: x.schemeTypeCode === 'WHT' ? -tempTaxAmount : tempTaxAmount, //uncomment this if need to minus the WHT tax
      TaxRate: x.taxRate! / 100,
      taxCode: x.taxCode,
      schemeTypeCode: x.schemeTypeCode,
    })
  })

  const totalTaxAmount = Number(
    taxLedgerList
      .reduce((accumulator, currentValue) => {
        return accumulator + currentValue.TaxAmount
      }, 0)
      .toFixed(2)
  )

  const result: calculateTaxOutput = {
    IncludeTaxAmount: isExclusiveTax
      ? Number((originalAmount + totalTaxAmount).toFixed(2))
      : originalAmount,
    ExcludeTaxAmount: isExclusiveTax
      ? originalAmount
      : Number((originalAmount - totalTaxAmount).toFixed(2)),
    TaxAmount: totalTaxAmount,
    taxDetails: taxLedgerList,
  }

  return result
}

export { calculateTaxDetail }
